import { DnaTestTrackingStatus } from "@/features/holifya-tests/dna-test/types/DnaTestTrackingStatus";
import { create } from "zustand";
import { BloodTestTrackingStatus } from "../enums/TrackingStatus";

interface TrackersData {
    bloodStatus: BloodTestTrackingStatus | null;
    dnaStatus: DnaTestTrackingStatus | null;
    dnaOrderId: string | null;
}

interface TrackersStore {
    trackers: TrackersData;
    updateTrackers: (updates: Partial<TrackersData>) => void;
    clearTrackers: () => void;
}

export const useTrackersStore = create<TrackersStore>((set) => ({
    trackers: JSON.parse(localStorage.getItem("trackers") || "{}") as TrackersData || {
        bloodStatus: null,
        dnaStatus: null,
        dnaOrderId: null,
    },

    updateTrackers: (updates) => {
        set((state) => {
            const newTrackers = { ...state.trackers, ...updates };
            localStorage.setItem("trackers", JSON.stringify(newTrackers));
            return { trackers: newTrackers };
        });
    },

    clearTrackers: () => {
        set({ trackers: { bloodStatus: null, dnaStatus: null, dnaOrderId: null } });
        localStorage.removeItem("trackers");
    },
}));